<template>
  <nuxt-link
    class="c-nav-card"
    :class="{
      'c-nav-card--new': navItem.new
    }"
    :to="navItem.linkUrl || '#'"
  >
    <template v-if="navItem">
      <div
        class="c-nav-card__wrapper"
        :class="[
          'l-flex',
          'l-flex__nowrap',
          'u-overflow-hidden',
        ]"
      >
        <div class="c-nav-card__image-wrapper">
          <nuxt-img
            v-if="navItem.image && navItem.image.src"
            class="c-nav-card__image"
            v-bind="$getImgOptions(navItem.image, {
              preset: 'nav-card',
              alt: navItem.title
            })"
          />
        </div>
        <div
          class="c-nav-card__copy"
          :class="[
            'u-overflow-hidden',
          ]"
        >
          <header
            class="c-nav-card__header"
            :class="['t-heading-8']"
          >
            {{ navItem.title }}
          </header>
          <header
            v-if="navItem.subtitle && navItem.subtitle.length > 0"
            class="c-nav-card__subheader"
            :class="{
              'c-nav-card__subheader--accent': navItem.highlightSubtitle,
              't-heading-13': true,
              't-heading-13--light': true,
              'u-margin-bottom-xx-small': true,
            }"
          >
            {{ navItem.subtitle }}
          </header>
          <p
            v-if="navItem.description"
            class="c-nav-card__description u-margin-bottom-x-small"
            :class="['t-heading-11', 't-paragraph-small—x-light']"
          >
            {{ navItem.description }}
          </p>
        </div>
      </div>
    </template>
  </nuxt-link>
</template>

<script>
import { UrlFilters } from '@mixins/cdnMixins'

export default {
  name: "NavCard",
  mixins: [ UrlFilters ],
  props:{
    navItem: {
      type: Object,
      default: () => ({}),
    }
  },
}
</script>
<style lang="scss" scoped>
  .c-nav-card {
    padding: rem(4px) rem(19px);
    cursor: pointer;
    display: block;
    text-decoration: none;

    &--new {
      background-image: url("~@/assets/images/new_badge_blue.png");
      background-repeat: no-repeat;
      background-position: right rem(10px) top rem(10px);
      background-size: rem(47px) rem(20px);
    }

    &__wrapper {
      overflow: hidden;
      width: 100%;
      height: 100%;
    }

    &__header {
      margin-top: rem(11px);
      padding-right: rem(40px);
      font-weight: 700;
      line-height: 114.5%;
    }

    &__copy {
      align-self: baseline;
      padding-left: rem(30px);
      flex: 1;
    }

    @include themify($themes) {
      background-color: themed("background", "xx-light");
      color: themed("foreground", "base");
    }

    &__image {
      max-width: rem(122px);
      min-width: rem(122px);
      max-height: 100%;
      width: 100%;
      height: 100%;
      min-height: rem(115px);
      object-fit: contain;
    }

    &__image-wrapper {
      width: rem(100px);
    }

    &__subheader {
      text-transform: uppercase;
      &--accent {
        @include themify($themes) {
          color: themed("accent", "base");
        }
      }
    }

    &__description {
      text-transform: uppercase;
      font-weight: 700;
      @include themify($themes) {
        color: themed("foreground", "x-light-text");
      }
    }

  }
</style>
